import * as Yup from "yup";

export const BranchSchema = Yup.object({
    name: Yup.string().required(" Enter Branch Name").matches(/^[a-zA-Z0-9!@#$%&()-`.+,/\"]/, "Empty Space Not Allow"),   
    status: Yup.string().required(" Select Status"),
    
});